import {
  put, call, select, all,
} from 'lib/redux';
import * as types from 'constants/ActionTypes';
import getOrderClosureReasonsService from 'services/getOrderClosureReasons.service';
import cancelOrderService from 'services/cancelOrder.service';
import { SUCCESS, ERROR, USER_EVENTS } from 'constants/AppConstants';
import history from 'store/CreateHistory';
import { CANCEL_ORDER_RESPONSE, CANCEL_ORDER_LOADING } from 'constants/ActionTypes';
import { ORDER_HISTORY_ROUTE } from 'constants/RouteConstants';
import { loadOrderHistoryPage } from 'features/orderHistory/OrderHistory.actions';
import { logError } from 'utils/logger.utils';
import { trackUserEvent } from 'utils/app.utils';

export function* fetchOrderClosureReasonsSaga() {
  try {
    const closureReasonsList = yield select(({ cancelOrder }) => cancelOrder.closureReasons);
    // Fetch closure reasons only if not fetched already
    if (closureReasonsList.length === 0) {
      const response = yield call(getOrderClosureReasonsService);
      if (!response.ok) {
        const error = new Error(response.json.errorDescription);
        error.errorCode = response.json.errorCode;
        throw error;
      }
      const { json: closureReasons } = response;

      yield put({ type: types.ORDER_CLOSURE_REASONS_SUCCESS, closureReasons });
    }
  } catch (error) {
    logError('Error in fetchOrderClosureReasonsSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
    yield put({ type: '', error: error.message });
  }
}

export function* cancelOrderSaga({ requestBody: request }) {
  try {
    trackUserEvent(USER_EVENTS.CANCEL_ORDER);
    yield put({ type: CANCEL_ORDER_LOADING });
    const { reportId: reportIds, ...requestBody } = request;
    let ok;
    if (Array.isArray(reportIds)) {
      const responses = yield all(reportIds.map((reportId) => call(cancelOrderService, { reportId, ...requestBody })));
      ok = responses.every(({ ok: responseOk }) => Boolean(responseOk));
    } else {
      const response = yield call(cancelOrderService, { reportId: reportIds, ...requestBody });
      ok = response.ok;
    }

    if (history.location.pathname === ORDER_HISTORY_ROUTE) yield put(loadOrderHistoryPage());
    else history.push(ORDER_HISTORY_ROUTE);

    yield put({ type: CANCEL_ORDER_RESPONSE, responseStatus: ok ? SUCCESS : ERROR });
  } catch (error) {
    logError('Error in cancelOrderSaga', {
      error: error.message,
      errorCode: error.errorCode,
      request,
    });
    yield put({ type: '', error: error.message });
  }
}
